module.exports = __webpack_public_path__ + "img/zx_login_banner.png";